import { CSSObject, Drawer, ListItemButton, styled, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const DRAWER_WIDTH = 170;

const ListItemSelected = (theme: Theme): CSSObject => ({
    backgroundColor: theme.palette.primary.main,
    '.MuiSvgIcon-root': {
        fill: theme.palette.primary.contrastText,
    },
    '.MuiTypography-root': {
        color: theme.palette.primary.contrastText,
    },
    ':hover': {
        backgroundColor: theme.palette.primary.main,
    },
});

export const ListItemButtonWrapper = styled(ListItemButton)(({ theme, selected }) => ({
    ...(selected && {
        ...ListItemSelected(theme),
        '&.Mui-selected': ListItemSelected(theme),
    }),
    ...{
        '.MuiSvgIcon-root': {
            fill: alpha(theme.palette.primary.main, 0.5),
        },
    },
}));

export const Wrapper = styled(Drawer, {
    shouldForwardProp: prop => prop !== 'open',
})(({ theme }) => ({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    borderRight: `none`,
    overflow: 'auto',
    ...{
        '.MuiPaper-root': {
            position: 'relative',
        },
    },
    ...{
        '.listItem-active': {
            '.listItem-icon': {
                fill: theme.palette.primary.main,
            },
            '> .MuiButtonBase-root .MuiTypography-root': {
                fontWeight: 700,
            },
        },
    },
}));
